export default class AncestorUnit {
  generationId = 0
  individual = null
  isBetweenParents = false
  isOrphan = false
  isParent = false
  hasMoreChildren = false
}